// @ts-strict-ignore
export function sumArray(list: number[]): number {
  return list.reduce((a, b) => a + b, 0);
}

export const unique = <T>(value: T, index: number, self: T[]): boolean => self.indexOf(value) === index;

export function uniqueByKeys<T extends Record<string, any>>(
  keys: (keyof T)[]
): (value: T, index: number, self: T[]) => boolean {
  return (value: T, index: number, self: T[]): boolean => {
    return self.findIndex((item) => keys.every((key) => item[key] === value[key])) === index;
  };
}

export function flattenOnPropertyReducer<T extends { [P in keyof Pick<T, K>]: T[] }, K extends keyof T>(
  property: K,
  filter?: (node: T) => boolean
): (array: T[], node: T) => T[] {
  function flattenOnProperty(array: T[], node: T): T[] {
    if (node) {
      if (!filter || filter(node)) {
        array.push(node);
        return node[property].reduce<T[]>(flattenOnProperty, array);
      }
      return array;
    }
  }
  return flattenOnProperty;
}
